import moment from 'moment';

function Row(props) {

    return (
        <tr key={props.index} className={'report-row'}>
            {
                props.metadata.columns.map((c, idx) => {

                    let value = props.data[c.field];
                    if (c.type === 4) {
                        if (value) {
                            let dateformat = new moment(value);
                            if (dateformat.isValid()) {
                                value = dateformat.format(c.format);
                            } else {
                                value = 'Invalid date';
                            }
                        } else {
                            value = '';
                        }
                    }
                    else if (c.type === 3) {
                        let boolArr = c.format.split('|');
                        value = value ? boolArr[0] : boolArr[1];
                    }
                    return (
                        <td key={`td-${idx}`} className={c.className}>{value}</td>
                    );
                })
            }
        </tr>);
}

export default Row;